import { render, staticRenderFns } from "./B2BForm.vue?vue&type=template&id=6dac8863&scoped=true"
import script from "./B2BForm.vue?vue&type=script&lang=js"
export * from "./B2BForm.vue?vue&type=script&lang=js"
import style0 from "./B2BForm.vue?vue&type=style&index=0&id=6dac8863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac8863",
  null
  
)

export default component.exports